import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import styles from './LoadingBar.module.css';

type Props = {
  isLoading?: boolean;
};

const LoadingBar = ({ isLoading = false }: Props) =>
  isLoading ? (
    <div className={styles.root}>
      <LinearProgress className={styles.progress} />
    </div>
  ) : null;

export default LoadingBar;
